import clsx from 'clsx'
import { ReactElement, ReactNode } from 'react'
import { Drawer } from 'beam/dist/Drawer'
import { ClassNameMap } from '@mui/material'

export interface ExpandableDrawerProps {
  open?: boolean,
  expanded?: boolean,
  anchor?: 'left' | 'top' | 'right' | 'bottom',
  children: ReactNode,
  classes: ClassNameMap<'drawerPaper' | 'drawerPaperExpanded'>,
}

// From Beam but with support for passed in classes
export function ExpandableDrawer({ open = false, expanded = false, anchor = 'left', children, classes }: ExpandableDrawerProps): ReactElement {
  return (
    <Drawer
      open={open}
      anchor={anchor}
      variant="persistent"
      classes={{
        paper: clsx(
          classes.drawerPaper,
          open && expanded && classes.drawerPaperExpanded,
        ),
      }}
    >
      {children}
    </Drawer>
  )
}

export default ExpandableDrawer
